<template>
  <fieldset class="radio-group">
    <legend class="radio-group__legend">
      {{ label }}
      <span v-if="required" class="radio-group__required">*</span>
    </legend>
    <div :class="['radio-group__options', { 'radio-group__options--error': error }]">
      <label class="radio-group__option" v-for="(option, i) in options" :key="i">
        <input type="radio" @click="check(option.value)" />
        <span :class="['radio-group__state', { 'radio-group__state--checked': isChecked(option.value) }]"></span>
        <span class="radio-group__label">{{ option.label }}</span>
      </label>
    </div>
    <p class="radio-group__error" v-if="error">{{ error }}</p>
    <p class="radio-group__hint" v-else-if="hint">{{ hint }}</p>
  </fieldset>
</template>

<script>
export default {
  name: 'RadioGroup',
  props: {
    value: { type: [Boolean, Number, String] },
    options: { type: Array, required: true, default: () => [] },
    required: { type: Boolean },
    label: { type: String },
    error: { type: String },
    hint: { type: String },
  },
  computed: {
    vModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    check(v) {
      this.vModel = v
    },

    isChecked(v) {
      return v === this.vModel
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.radio-group
  position: relative

  &__legend
    display: inline-block
    font-size: 14px
    line-height: 1.3

  &__options
    display: flex
    gap: 24px
    align-items: center
    margin-top: 8px

    &--error
      .radio-group__state
        &, &--checked
          opacity: 1
          border-color: $error

  &__option
    display: flex

  &__state
    position: relative
    border: 1px solid #E7E7E8
    border-radius: 50%
    opacity: 0.5
    width: 24px
    height: 24px
    transition: all .2s

    &:after
      content: ''
      position: absolute
      top: 4px
      left: 4px
      width: 14px
      height: 14px
      background: #00b0bd
      border-radius: 50%
      opacity: 0
      transition: opacity .2s, border-color .2s

    &--checked
      background-color: #F5F5FA
      border: 1px solid #F5F5FA
      opacity: 1

      &:after
        opacity: 1

  &__label
    font-size: 14px
    color: $shades-black
    margin-left: 8px

  &__required
    font-size: 13px

  &__error, &__hint
    position: absolute
    bottom: -15px
    font-size: 12px
    line-height: 1

  &__required, &__error
    color: $error
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/form/RadioGroup.vue